import { useQuery } from '@vrplatform/data';
import { emptyUUID, isUUID } from '@vrplatform/utils';
import { useDebouncedValue } from '@mantine/hooks';
import type { ConnectionExtractor } from '../extract-single-modal/useExtractSingleButtonQuery';
import { filterVisibleExtractors } from './useExtractModalQuery.utils';

export const STORYBOOK_EXTRACT_MODAL_QUERY_KEY = 'extract-modal-query';

export const useExtractModalQuery = ({
  extractConnectionIds,
  opened,
}: {
  extractConnectionIds: string[];
  opened: boolean;
}) => {
  const skip = extractConnectionIds.length !== 1 || !opened;

  const {
    data,
    isLoading: loading,
    refetch,
  } = useQuery(
    (q, args) => {
      if (!isUUID(args.connectionId || ''))
        return {
          connection: null,
        };

      const connection = q.connectionById({
        id: args.connectionId || emptyUUID,
      });

      const extractors = (connection.app.info({
        path: 'extractors',
      }) || []) as ConnectionExtractor[];

      return {
        connection: {
          id: connection?.id,
          name: connection?.name,
          logo: connection?.app?.iconRound,
          extractors: filterVisibleExtractors(extractors),
        },
      };
    },
    {
      skip,
      storybookQueryKey: STORYBOOK_EXTRACT_MODAL_QUERY_KEY,
      variables: {
        connectionId: extractConnectionIds[0],
      },
    }
  );

  const [debouncedConnection] = useDebouncedValue(data?.connection, 300);

  const connection = data?.connection || debouncedConnection;

  return {
    loading,
    connection,
    refetch,
  };
};
